export class TblColumnDefinitions {
  version: string;
  columnDefinitionJsonString: string;
}
